import * as types from '../types/operators'
import createReducer from '../createReducer'

const initOperatorsState = {}

export default createReducer(initOperatorsState, {
  [types.UPDATE_EXISTING_OPERATOR](state, action) {
    const newOperators = state
    newOperators[action.operator._id] = action.operator
    return Object.assign({}, state, newOperators)
  },
  [types.SET_ALL_OPERATORS](state, action) {
    return Object.assign({}, state, action.operators)
  },
  [types.ADD_NEW_OPERATOR](state, action) {
    return Object.assign({}, state, { [action.operator._id]: action.operator })
  },
  [types.DELETE_OPERATOR](state, action) {
    const newState = Object.assign({}, state)
    delete newState[action.operator._id]
    return newState
  },
})
